<div mat-dialog-title>
  <p8-layout-settings-header [titlePath]="[dialogData.title]"
                             [iconRacine]="'check_circle'"></p8-layout-settings-header>
  <mat-card-subtitle *ngIf="dialogData.subtitle" style="padding-top: 10px;">{{dialogData.subtitle}}</mat-card-subtitle>
</div>

<mat-dialog-content>
  <div class="mat-typography">
    <span *ngIf="dialogData?.message" [innerHTML]="dialogData.message | safeHtml" style="float: left;width: 100%;"></span>
    <ng-container [formGroup]="form">
      <mat-form-field style="width: 100%;">
        <textarea formControlName="contentData" matInput placeholder="{{dialogData?.contentPlaceHolder}}" style="min-height: 120px;" required></textarea>
        <mat-hint align="end"><code>{{form?.get('contentData')?.value?.length}}</code></mat-hint>
      </mat-form-field>
    </ng-container>
  </div>
  <div class="mat-typography" *ngIf="data.stateToChange !== responseStateInstruction.incomplete">
    <app-ldap-lists-select [formId]="data.formId"
                           (onPersonsUpdated)="listPersonInCopy($event)"></app-ldap-lists-select>
  </div>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'" style="float: right">
  <ng-container>
    <button mat-raised-button
            [color]="''"
            [matDialogClose]="false">
      Annuler
    </button>
    <button mat-raised-button
            [color]="'primary'"
            [disabled]="isDisabled()"
            (click)="save()" >
      Valider la décision
    </button>
  </ng-container>
</mat-dialog-actions>

